const IS_LOCAL_ENVIRONMENT = window.location.href.includes('localhost')
const IS_PROD_ENVIRONMENT = process.env.VUE_APP_ENV === 'production'

export default {
  IS_LOCAL_ENVIRONMENT,
  IS_PROD_ENVIRONMENT
}
